module.exports = __webpack_public_path__ + "static/hexagons-left-d4090a28be602f9ceb5bb1945a7ca3d4.png";